import { AllUnMapcategory, portal_map_list } from "./api.js";

const MENU_KEY = "bb_header_menu";
const PORTAL_KEY = "bb_header_portals";

let menuMemory = null;
let menuRaw = null;
let menuRequest = null;

let portalMemory = null;
let portalRaw = null;
let portalRequest = null;

function readStored(key, memory, raw) {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return { data: null, raw: null };
    if (stored === raw && memory) return { data: memory, raw };
    const parsed = JSON.parse(stored);
    if (parsed == null || typeof parsed !== "object") return { data: null, raw: null };
    return { data: parsed, raw: stored };
  } catch (error) {
    return { data: null, raw: null };
  }
}

function writeStored(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    // Storage can be full or blocked. The in-memory copy still serves this page load.
  }
}

export function readHeaderMenu() {
  const stored = readStored(MENU_KEY, menuMemory, menuRaw);
  const menu = Array.isArray(stored.data) ? stored.data : null;
  menuMemory = menu;
  menuRaw = menu ? stored.raw : null;
  return menu;
}

export function readHeaderPortals() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  const stored = readStored(PORTAL_KEY, portalMemory, portalRaw);
  const match = stored.data && stored.data.token === token && Array.isArray(stored.data.items);
  portalMemory = match ? stored.data : null;
  portalRaw = match ? stored.raw : null;
  return match ? stored.data.items : null;
}

export function pickMenu(data, slug) {
  if (!Array.isArray(data)) return [];
  return data.find((item) => item.Slug === slug) || [];
}

// One network call for the whole visit. Later pages, and a refresh, read localStorage.
export function getHeaderMenu() {
  const cached = readHeaderMenu();
  if (cached) return Promise.resolve(cached);

  if (!menuRequest) {
    menuRequest = AllUnMapcategory()
      .then((response) => {
        const data = response?.data?.Data;
        if (!Array.isArray(data)) throw new Error("Menu data missing");
        writeStored(MENU_KEY, data);
        menuRaw = localStorage.getItem(MENU_KEY);
        menuMemory = data;
        return data;
      })
      .finally(() => {
        menuRequest = null;
      });
  }

  return menuRequest;
}

export function getHeaderPortals() {
  if (!localStorage.getItem("token")) return Promise.resolve([]);

  const token = localStorage.getItem("token");
  const cached = readHeaderPortals();
  if (cached) return Promise.resolve(cached);

  if (!portalRequest) {
    portalRequest = portal_map_list()
      .then((response) => {
        const data = Array.isArray(response?.data?.data) ? response.data.data : [];
        writeStored(PORTAL_KEY, { token, items: data });
        portalRaw = localStorage.getItem(PORTAL_KEY);
        portalMemory = { token, items: data };
        return data;
      })
      .finally(() => {
        portalRequest = null;
      });
  }

  return portalRequest;
}
